import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import { DrawingBomContext } from "../../DrawingBomContext";
import { modalStyle } from "../../../../../../../../components/modalStyle";
import { drawingMaterialsCols } from "../../../Components/cols/drawingsMaterialsCols";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";

export default function MtrModal() {
  const { openMtr, handleCloseMtrModal, selectedDrawings } =
    React.useContext(DrawingBomContext);

  // console.log({ selectedDrawings });

  const data = [];

  selectedDrawings.forEach((d) => {
    d?.materials?.forEach((m) => {
      data.push(m);
    });
  });
  const table = useMaterialReactTable({
    columns: [
      ...drawingMaterialsCols(selectedDrawings?.[0]?.materials),
      {
        header: "Heat #",
        accessorKey: "heatNumber",
        size: 50,
      },
    ],
    data: data.sort((a, b) => a?.item - b?.item),
    ...lightTable,
  });
  return (
    <div>
      <Modal open={openMtr} onClose={handleCloseMtrModal}>
        <Box sx={{ ...modalStyle, width: "55%", maxHeight: "95%" }}>
          <Typography variant="h5" sx={{ pb: 2 }}>
            Material Traceability Records (MTR):{" "}
          </Typography>
          <MaterialReactTable table={table} />
        </Box>
      </Modal>{" "}
    </div>
  );
}
